import { BaseService } from './baseService';

class VehicleService extends BaseService {
    constructor() {
        super('/api/veiculos');
    }

    /**
     * Lista veículos com filtros específicos
     * Mapeia filtros customizados para os parâmetros da API
     */
    async list({ page = 0, size = 5, sort = 'model,asc', model, licensePlate, chassis, active, ...otherFilters } = {}) {
        // Mapeia licensePlate para 'plate' (nome do parâmetro na API)
        const filters = {
            ...otherFilters,
        };
        
        if (model) filters.model = model;
        if (licensePlate) filters.plate = licensePlate;
        if (chassis) filters.chassis = chassis;
        // Converte string "true"/"false" para boolean e envia apenas se não for vazio
        if (active !== undefined && active !== null && active !== '') {
            // Converte string para boolean se necessário
            if (active === 'true') {
                filters.active = true;
            } else if (active === 'false') {
                filters.active = false;
            } else {
                filters.active = active;
            }
        }

        return super.list({ page, size, sort, filters });
    }

    /**
     * Alterna o status de um veículo
     */
    async toggleStatus(id) {
        return this.patch(id, 'status');
    }
}

const vehicleService = new VehicleService();
export default vehicleService;
